var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationPrimaryColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/information"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7528 2.45031C11.4528 1.86031 12.5828 1.86031 13.2628 2.45031L14.8428 3.80031C15.1428 4.05031 15.7128 4.26031 16.1128 4.26031H17.8128C18.8728 4.26031 19.7428 5.13031 19.7428 6.19031V7.89031C19.7428 8.29031 19.9528 8.85031 20.2028 9.15031L21.5528 10.7303C22.1428 11.4303 22.1428 12.5603 21.5528 13.2403L20.2028 14.8203C19.9528 15.1203 19.7428 15.6803 19.7428 16.0803V17.7803C19.7428 18.8403 18.8728 19.7103 17.8128 19.7103H16.1128C15.7128 19.7103 15.1528 19.9203 14.8528 20.1703L13.2728 21.5203C12.5728 22.1103 11.4428 22.1103 10.7628 21.5203L9.18281 20.1703C8.88281 19.9203 8.31281 19.7103 7.92281 19.7103H6.17281C5.11281 19.7103 4.24281 18.8403 4.24281 17.7803V16.0703C4.24281 15.6803 4.04281 15.1103 3.79281 14.8203L2.44281 13.2303C1.86281 12.5403 1.86281 11.4203 2.44281 10.7303L3.79281 9.14031C4.04281 8.84031 4.24281 8.28031 4.24281 7.89031V6.20031C4.24281 5.14031 5.11281 4.27031 6.17281 4.27031H7.90281C8.30281 4.27031 8.86281 4.06031 9.16281 3.81031L10.7528 2.45031Z",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 8.13281V12.9628",
    stroke: "#246BFD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.9922 16H12.0012",
    stroke: "#246BFD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationPrimaryColor);
export default __webpack_public_path__ + "static/media/informationPrimaryColor.819264b29cd8e70d4c040b8930940dc0.svg";
export { ForwardRef as ReactComponent };